/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const RulerIcon = /*#__PURE__*/ createSvgIcon(
  'RulerIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M3.5 15c-.413 0-.766-.147-1.06-.44A1.445 1.445 0 012 13.5v-7c0-.412.147-.766.44-1.06.294-.293.647-.44 1.06-.44h13c.413 0 .766.147 1.06.44.293.294.44.647.44 1.06v7c0 .412-.147.766-.44 1.06-.294.293-.647.44-1.06.44h-13zm0-1.5h13v-7H14v2.75c0 .213-.072.39-.214.534a.72.72 0 01-.532.216.734.734 0 01-.535-.216.72.72 0 01-.219-.534V6.5h-1.75v2.75c0 .213-.072.39-.214.534a.72.72 0 01-.532.216.734.734 0 01-.535-.216.72.72 0 01-.219-.534V6.5H7.5v2.75c0 .213-.071.39-.214.534a.72.72 0 01-.532.216.734.734 0 01-.535-.216A.72.72 0 016 9.25V6.5H3.5v7z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default RulerIcon;
